import { inject } from "@angular/core"
import { Subject } from "rxjs"
import { ReAuthenticationService } from "./features/reAuthentication/reAuthentication.service"
import { AuthenticationService } from "./services/authentication/authentication.service"
import { Option } from "./types/option"
import { AuthService } from "./api-client/services/auth.service"
import { isAccessRevokedError } from "./interceptors/accessRevoked.interceptor"

// Safari has no requestIdleCallback. Calling it there throws before the initializer
// completes, so the app never bootstraps and the page stays blank.
const whenIdle = (callback: () => void) => {
    if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(callback)
    } else {
        setTimeout(callback)
    }
}

export const initializeApp = () => {
    const _authenticationService = inject(AuthenticationService)
    const _reAuthenticationService = inject(ReAuthenticationService)
    const _loaded = new Subject<void>()
    inject(AuthService).getAuthInfo().subscribe({
        next: (authenticatedUser) => {
            _authenticationService.authenticatedUser.set(Option.toOption(AuthenticationService.toPayload(authenticatedUser)))
            _loaded.complete()
        },
        error: (error) => {
            console.error("Error loading authentication info", error)
            // A denied account gets an empty-bodied 403 on every request; the
            // accessRevokedInterceptor routes to the Access Revoked page, so do not
            // also open the login dialog (logging in again cannot help).
            if (!isAccessRevokedError(error)) {
                whenIdle(()=>_reAuthenticationService.triggerAuthentication(true))
            }
            _loaded.complete()
        }
    })
    return _loaded.asObservable()
}